

















































































import {
  computed,
  defineComponent,
  PropType,
  ref,
  toRefs
} from '@nuxtjs/composition-api'
import { TradeClassified } from '~/models/trades/types'
import TradesAlertCircle from '~/components/car/trades/TradesAlertCircle.vue'
import { ciTradesMatch } from '~/icons/source/regular/trades-match'
import CConfirmationModal from '~/components/shared/configurable/modal/CConfirmationModal.vue'
import { useNamespacedStore } from '~/compositions/store'
import { TRADES_NS, TradesState } from '~/store/modules/shared/trades/state'
import { removeTradableClassified } from '~/store/modules/shared/trades/actions-types'
import { faTrash } from '@fortawesome/free-solid-svg-icons'

export default defineComponent({
  components: { CConfirmationModal, TradesAlertCircle },
  props: {
    classified: {
      type: Object as PropType<TradeClassified>,
      required: true
    },
    inIndex: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(props) {
    const { classified } = toRefs(props)
    const routeForClassified = computed(() => {
      return {
        name: '__trades_swipe',
        params: { cid: classified.value.id }
      }
    })
    const showRemoveConfirm = ref(false)
    const { dispatch } = useNamespacedStore<TradesState>(TRADES_NS)

    const hasNotificaitons = computed(() => {
      const clsfd = classified.value
      if (clsfd.notifications) {
        return Boolean(
          clsfd.notifications.tradesLikedBy ||
            clsfd.notifications.tradesMessage ||
            clsfd.notifications.tradesMatched
        )
      }
      return false
    })

    const removeTrade = async () => {
      await dispatch(removeTradableClassified, classified.value.id)
    }

    return {
      routeForClassified,
      hasNotificaitons,
      ciTradesMatch,
      faTrash,
      showRemoveConfirm,
      removeTrade
    }
  }
})
